import { i18n } from '@/plugins/i18n'
import { AgreementStatus, AgreementType } from '@/constants'
import { invertKeyValues } from '@/common/objects'

export const statusStr = (agreement) => {
    const status = invertKeyValues(AgreementStatus)[agreement.status]

    return status ? i18n.t(`agreement.statuses.${status.toLowerCase()}`) : 'undefined'
}

export const statusColor = (agreement) => {
    const colors = {
        [AgreementStatus.PENDING]: 'light',
        [AgreementStatus.REDIRECTED]: 'secondary',
        [AgreementStatus.APPROVED]: 'success',
    }

    return colors[agreement.status]
}

export const typeStr = (agreement) => {
    const type = invertKeyValues(AgreementType)[agreement.type]

    return type ? i18n.t(`agreement.types.${type.toLowerCase()}`) : 'undefined'
}